import { render, staticRenderFns } from "./SelectProjectCardToPlay.vue?vue&type=template&id=9c77be74&"
import script from "./SelectProjectCardToPlay.vue?vue&type=script&lang=ts&"
export * from "./SelectProjectCardToPlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports